import React from 'react';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../lib/PropTypes';

const directionTransform = {
    right: null,
    left: 'rotate(180) translate(-30, -30)',
    top: 'rotate(180) translate(0, -30)',
    bottom: 'rotate(180) translate(0, 30)',
};

const propTypes = {
    direction: AppPropTypes.arrowDirection,
    color: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string,
};

const defaultProps = {
    direction: 'right',
    color: 'currentColor',
    className: null,
    type: null,
};

const Arrow = ({ direction, color, className, type }) => {
    if(type === 'chevron') {
        return (
            <svg
                id="chronologie"
                xmlns="http://www.w3.org/2000/svg"
                width="40px"
                height="40px"
                fill="none"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth="3px"
                viewBox="0 0 22.72 40.36">
                <polyline className="cls-1" points="1.03 1.09 20.6 19.65 20.49 19.76 1.93 39.33"/>
            </svg>
        );
    } else {
        return (
            <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0"
                y="0px"
                width="30px"
                height="30px"
                viewBox="0 0 30 30"
                className={className}
                xmlSpace="preserve"
            >
                <g transform={directionTransform[direction]}>
                    <path fill={color} d="M18.4,14.3L14,10l1-1l6,6l-6,6l-1-1.1l4.3-4.2H9v-1.4H18.4z" />
                </g>
            </svg>
        );
    }
};

Arrow.propTypes = propTypes;
Arrow.defaultProps = defaultProps;

export default Arrow;
